import React from "react";
import withStyles from "@mui/styles/withStyles";
import { CircularProgress, Typography } from "@mui/material";

const styles = (theme) => ({
  loading: {
    color: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    justifyContent: "center",
    margin: theme.spacing(5, 0),
  },
});

const Loading = ({ classes, item = "" }) => {
  return (
    <div className={classes.loading}>
      <Typography variant="h5" fontWeight={500}>
        Loading {item}...
      </Typography>
      <CircularProgress color="primary" size={25} />
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(Loading);
